import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal, inject } from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { OptionsBoardSettingsInterface } from '@shared/components/trading/widgets/options-board-widget/core/interfaces/options-board-settings.interface'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { DropdownColumnsActionsComponent } from '@shared/components/trading/widgets/common/dropdown-columns-actions/dropdown-columns-actions.component'
import { OptionsBoardColumnsEnum } from '../core/enums/options-board-columns.enum'
import { ColumnInterface } from '@shared/interfaces/column.interface'
import { WidgetsService } from '@modules/widgets-module/services/widgets.service'

@UseLocales({ ru, en })
@Component({
	selector: 'app-options-board-widget-actions',
	templateUrl: './options-board-widget-actions.component.html',
	styleUrl: './options-board-widget-actions.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [DropdownColumnsActionsComponent],
})
export class OptionsBoardWidgetActionsComponent {
	public widget: InputSignal<WidgetInterface<OptionsBoardSettingsInterface> | null> =
		input<WidgetInterface<OptionsBoardSettingsInterface> | null>(null)

	private readonly _widgetsService: WidgetsService = inject<WidgetsService>(WidgetsService)

	protected columns: Signal<ColumnInterface<OptionsBoardColumnsEnum>[]> = computed<
		ColumnInterface<OptionsBoardColumnsEnum>[]
	>((): ColumnInterface<OptionsBoardColumnsEnum>[] => {
		const widget: WidgetInterface<OptionsBoardSettingsInterface> | null = this.widget()

		return widget?.settings.columns ?? []
	})
	protected onChangeColumns(columns: ColumnInterface<OptionsBoardColumnsEnum>[]): void {
		const widget: WidgetInterface<OptionsBoardSettingsInterface> | null = this.widget()
		if (!widget) return

		this._widgetsService.updateWidget({
			...widget,
			settings: {
				...widget.settings,
				columns,
			},
		})
	}
}
